import React from "react";

const HighSchoolContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            10th Class (High School)
          </h1>
          <p className="text-[15px] font-medium">
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              High School Examination Certificate (HSEC)
            </h1>
            "HSEC" means High School Examination Certificate (Matriculation i.e.
            X class) The examinations are conducted twice in a year in
            accordance with the syllabi prescribed by the Board. 20 marks of
            continuous & comprehensive evaluation have been allotted in each
            subject. After passing the examination, a certificate of
            qualification is awarded by the Board.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Eligibility Criteria
            </h1>
            In the secondary school certificate (10th class) course those who
            have completed 14 years of age as on 1st August of the year in which
            admission is sought for on the basis of and declaration to the
            effect that the candidate has studied enough to be able to pursue
            secondary certificate course under the open learning mode.
          </p>
        </div>
      </div>
    </>
  );
};

export default HighSchoolContainer;
